import React from 'react';
import { motion } from 'framer-motion';
import { type Role, type OptionData } from '../data/surveyData';
interface BarChartProps {
  options: OptionData[];
  currentRole: Role;
  userAnswerId: string;
}
export function BarChart({
  options,
  currentRole,
  userAnswerId
}: BarChartProps) {
  const maxValue = Math.max(...options.map(o => o.distributions[currentRole]));
  const userOption = options.find(o => o.id === userAnswerId);
  const userPct = userOption ? userOption.distributions[currentRole] : 0;
  const isTopAnswer = userOption ? userOption.distributions[currentRole] === maxValue : false;
  return <div className="space-y-4" data-id="element-16">
      <div className="space-y-3" data-id="element-17">
        {options.map((option, index) => {
        const value = option.distributions[currentRole];
        const isUserAnswer = option.id === userAnswerId;
        const barWidth = value / 100 * 100;
        return <div key={`${option.id}-${currentRole}`} className="space-y-1" data-id="element-18">
              <div className="flex items-center justify-between gap-2" data-id="element-19">
                <span className={`text-xs leading-tight ${isUserAnswer ? 'font-bold text-era-red' : 'font-medium text-clinical-secondary'}`} data-id="element-20">
                  {option.text}
                  {isUserAnswer && <span className="ml-1.5 text-[10px] bg-era-red-light text-era-red px-1.5 py-0.5 rounded-full font-bold" data-id="element-21">
                      You
                    </span>}
                </span>
                <span className={`text-xs tabular-nums font-bold flex-shrink-0 ${isUserAnswer ? 'text-era-red' : 'text-clinical-muted'}`} data-id="element-22">
                  {value}%
                </span>
              </div>
              <div className="h-2.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-23">
                <motion.div className={`h-full rounded-full ${isUserAnswer ? 'bg-era-red' : 'bg-gray-300'}`} initial={{
              width: 0
            }} animate={{
              width: `${barWidth}%`
            }} transition={{
              duration: 0.5,
              delay: index * 0.08,
              ease: 'easeOut'
            }} key={`${option.id}-${currentRole}-bar`} data-id="element-24" />
              </div>
            </div>;
      })}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} className={`text-xs font-bold px-3.5 py-2.5 rounded-xl text-center ${isTopAnswer ? 'bg-era-teal-light text-era-teal' : 'bg-era-orange-light text-era-orange'}`} data-id="element-25">
        {isTopAnswer ? <>
            {userPct}% of your peers answered the same — you align with most
            peers
          </> : <>
            {userPct}% of your peers answered the same — you are in the minority
          </>}
      </motion.div>
    </div>;
}